import { render, staticRenderFns } from "./wordPronunciation.vue?vue&type=template&id=19654550&scoped=true&"
import script from "./wordPronunciation.ts?vue&type=script&lang=js&"
export * from "./wordPronunciation.ts?vue&type=script&lang=js&"
import style0 from "./wordPronunciation.less?vue&type=style&index=0&id=19654550&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19654550",
  null
  
)

export default component.exports